// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import DropdownMenu, {
  DropdownMenuItem
} from 'components/PageHeaderDropdownMenu';
import { setSearchSort } from '../redux/main/actions/mainSearch';

type OwnProps = {
  options: Array<{
    name: string,
    param: 'relevance' | 'newest'
  }>
};

type Props = OwnProps & {
  setSort: Function,
  sort: 'relevance' | 'newest',
  query: string
};

const SortMenu = ({ options, setSort, sort, query }: Props) => {
  const selected = options.find(option => option.param === sort);
  return query ? (
    <DropdownMenu
      data-qa-id="sort-menu"
      title={() => (selected ? selected.name : getText('Sort by'))}
      blue
    >
      {({ closeMenu }) => (
        <>
          {options
            .filter(option => sort !== option.param)
            .map(option => (
              <DropdownMenuItem
                key={option.param}
                onClick={() => {
                  closeMenu();
                  setSort(option.param);
                }}
                data-qa-id={`select-order-${option.param}`}
              >
                {option.name}
              </DropdownMenuItem>
            ))}
        </>
      )}
    </DropdownMenu>
  ) : null;
};

const mapStateToProps = ({ mainSearch: { sort, filters, query } }) => ({
  sort: sort[filters.type],
  query
});

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  { setSort: setSearchSort }
)(SortMenu);
